import React, { useState } from "react";
import CardMedia from "@mui/material/CardMedia";
import CustomLoadingGif from "../../../../../../assets/images/otros/loading-blanco.gif";
import NewLabel from "../../../../../../assets/images/otros/etiqueta_nuevo.png";

function ProductImage(props) {
  const [isLoading, setIsLoading] = useState(true);

  const handleImageLoad = () => {
    setIsLoading(false);
  };

  return (
    <div className="product-image-container">
      {isLoading && (
        <div className="loading-overlay">
          <img
            style={{ width: "250px" }}
            src={CustomLoadingGif}
            alt=""
          />
        </div>
      )}

      <CardMedia
        className={`CardMedia ${
          isLoading ? "image-loading" : "image-loaded"
        }`}
        component="img"
        image={props.image}
        onLoad={handleImageLoad}
      />

      {!isLoading && props.esNuevo && (
        <CardMedia
        component="img"
        image={NewLabel}
        alt="Nuevo"
        sx={{
          position: "absolute",
          top: 10,
          right: 10,
          width: 100,
          height: "auto",
          objectFit: "contain",
          zIndex: 10,
          pointerEvents: "none",
        }}
      />
      )}
    </div>
  );
}

export default ProductImage;
